import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

export default function LoginPage() {
  const { login, isAuthenticated, loading } = useAuth();

  if (loading) return null;
  if (isAuthenticated) return <Navigate to="/dashboard" replace />;

  return (
    <div style={{
      height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-0)',
    }}>
      {/* Background grid */}
      <div style={{
        position: 'fixed', inset: 0, opacity: 0.03,
        backgroundImage: 'linear-gradient(var(--text-0) 1px, transparent 1px), linear-gradient(90deg, var(--text-0) 1px, transparent 1px)',
        backgroundSize: '40px 40px',
        pointerEvents: 'none',
      }} />

      <div style={{
        background: 'var(--bg-1)', border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)', padding: '48px',
        width: '100%', maxWidth: '400px', textAlign: 'center',
        boxShadow: 'var(--shadow)', position: 'relative',
      }}>
        {/* Logo mark */}
        <div style={{
          width: 56, height: 56, borderRadius: 14,
          background: 'var(--accent-dim)', border: '1px solid var(--accent)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 24px', fontSize: 24,
        }}>
          🖥️
        </div>

        <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>
          Athens IT Asset Tracker
        </h1>
        <p style={{ color: 'var(--text-2)', fontSize: 14, marginBottom: 32, lineHeight: 1.6 }}>
          Sign in with your Athens Services Microsoft account to continue.
        </p>

        <button
          className="btn btn-primary"
          onClick={login}
          style={{ width: '100%', justifyContent: 'center', padding: '10px 20px', fontSize: 14 }}
        >
          <svg width="16" height="16" viewBox="0 0 23 23" fill="none">
            <path fill="#f35325" d="M1 1h10v10H1z"/>
            <path fill="#81bc06" d="M12 1h10v10H12z"/>
            <path fill="#05a6f0" d="M1 12h10v10H1z"/>
            <path fill="#ffba08" d="M12 12h10v10H12z"/>
          </svg>
          Sign in with Microsoft
        </button>

        <p style={{ color: 'var(--text-2)', fontSize: 12, marginTop: 24 }}>
          Access is restricted to Athens Services employees.<br />
          Contact IT if you need access.
        </p>
      </div>
    </div>
  );
}
